import React from 'react'
import styled from '@emotion/styled'

const Container = styled.div`
  width: 80%;
  display: grid;
  margin: 40px 0;
  grid-template-columns: repeat(auto-fit, minmax(355px, 1fr));
  grid-gap: 40px;
  grid-auto-rows: 1fr;
`

type Props = {
  children?: any
}

const DashboardProjectsContainer = ({ children }: Props) => <Container>{children}</Container>

export default DashboardProjectsContainer
